import { fetcher } from '@portal/shared/utils/fetcher';
import {
  AU_COUNTRY,
  EU_COUNTRIES,
  JP_COUNTRY,
  NZ_COUNTRY,
  UK_COUNTRIES
} from 'constants/locations';
import { NextRequest } from 'next/server';
import { StoreEnum } from 'schema/storeCode';

const CLOUDFRONT_COUNTRY_KEY = 'cloudfront-viewer-country';

export const detectCountryFromHeaders = async (request: NextRequest) => {
  const vercelGeo = request.headers.get('x-vercel-ip-country');
  let cloudfrontGeo = request.headers.get(CLOUDFRONT_COUNTRY_KEY);
  if (!cloudfrontGeo && !vercelGeo) {
    try {
      const base = request.headers.get('origin') || 'https://drinkag1.com';
      const { headers: cfHeaders } = await fetcher.get(`${base}/apis-edge/location`);
      cloudfrontGeo = cfHeaders[CLOUDFRONT_COUNTRY_KEY];
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }
  return (vercelGeo || cloudfrontGeo || 'US').toUpperCase();
};

export const mapCountryCodeToStore = (countryCode: string): StoreEnum => {
  if (UK_COUNTRIES.includes(countryCode)) {
    return StoreEnum.uk;
  }

  if (EU_COUNTRIES.includes(countryCode)) {
    return StoreEnum.eu;
  }

  if (countryCode === JP_COUNTRY) {
    return StoreEnum.jp;
  }

  if (countryCode === AU_COUNTRY) {
    return StoreEnum.au;
  }

  if (countryCode === NZ_COUNTRY) {
    return StoreEnum.nz;
  }

  return StoreEnum.us;
};

export const detectRequestGeoStore = async (request: NextRequest) => {
  const countryCode = await detectCountryFromHeaders(request);
  return mapCountryCodeToStore(countryCode);
};
